var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "data-statistic-container" },
    [
      _c(
        "div",
        { staticClass: "search-wrap", staticStyle: { position: "relative" } },
        [
          _c("div", { staticClass: "btn-group" }, [
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.btnActive == -1 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(-1)
                  }
                }
              },
              [_vm._v(" 昨日 ")]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.btnActive == 7 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(7)
                  }
                }
              },
              [_vm._v(" 近7日 ")]
            ),
            _c(
              "div",
              {
                staticClass: "btn",
                class: _vm.btnActive == 30 ? "btn-active" : "",
                on: {
                  click: function($event) {
                    return _vm.dateChange(30)
                  }
                }
              },
              [_vm._v(" 近30日 ")]
            )
          ]),
          _c("el-date-picker", {
            staticStyle: { width: "240px", "margin-right": "12px" },
            attrs: {
              size: "mini",
              editable: false,
              type: "daterange",
              "value-format": "yyyy-MM-dd",
              "range-separator": "-",
              "start-placeholder": "统计时间",
              "end-placeholder": "统计时间",
              "picker-options": _vm.pickerOptions,
              clearable: ""
            },
            on: { change: _vm.selectTime },
            model: {
              value: _vm.searchSelectTime,
              callback: function($$v) {
                _vm.searchSelectTime = $$v
              },
              expression: "searchSelectTime"
            }
          }),
          _c(
            "span",
            {
              staticClass: "tip",
              attrs: { slot: "reference" },
              on: {
                click: function($event) {
                  return _vm.openTipDialog(1)
                }
              },
              slot: "reference"
            },
            [_vm._v("统计说明 "), _c("i", { staticClass: "el-icon-question" })]
          ),
          _c(
            "div",
            { staticClass: "popover" },
            [
              _c(
                "el-popover",
                {
                  attrs: { placement: "bottom", width: "190", trigger: "click" }
                },
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "right",
                        "font-size": "12px"
                      }
                    },
                    [_vm._v(" 可选数量" + _vm._s(_vm.SelectSetLength) + "/10 ")]
                  ),
                  _c(
                    "div",
                    { staticClass: "list" },
                    _vm._l(_vm.setting, function(item, i) {
                      return _c(
                        "div",
                        {
                          staticClass: "item",
                          class: { active: item.isShow == 1 },
                          on: {
                            click: function($event) {
                              return _vm.selectItem(item)
                            }
                          }
                        },
                        [_vm._v(" " + _vm._s(item.fieldName) + " ")]
                      )
                    }),
                    0
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { slot: "reference", size: "small" },
                      slot: "reference"
                    },
                    [_vm._v("字段设置")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "card-wrap" },
        _vm._l(_vm.selectItemList, function(item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "card-item",
              class: {
                isClick:
                  _vm.topDataList[item].path && _vm.topDataList[item].isGo
              },
              on: {
                click: function($event) {
                  return _vm.clickItem(item)
                }
              }
            },
            [
              _c("img", {
                staticClass: "item-icon",
                attrs: { src: _vm.topDataList[item].icon, alt: "" }
              }),
              _c("div", { staticClass: "item-data" }, [
                _c("div", { staticClass: "data-title" }, [
                  _vm._v(_vm._s(_vm.topDataList[item].text))
                ]),
                _c("div", { staticClass: "data-num" }, [
                  _c(
                    "div",
                    {
                      staticClass: "card-content",
                      style: {
                        color:
                          _vm.topDataList[item] && _vm.topDataList[item].color
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.topDataList[item].value) + " ")]
                  ),
                  _vm.topDataList[item].path && _vm.topDataList[item].isGo
                    ? _c("i", { staticClass: "el-icon-arrow-right card-icon" })
                    : _vm._e()
                ])
              ])
            ]
          )
        }),
        0
      ),
      _c("div", { staticClass: "zhe-xian-wrap" }, [
        _c("div", { staticClass: "zhe-xian-title" }, [
          _c("div", { staticClass: "title-name-wrap" }, [
            _c(
              "span",
              {
                staticClass: "title-name ",
                class: _vm.type == 1 ? "title-more" : "",
                on: { click: _vm.getCusStatistic }
              },
              [_vm._v("新增客户波动")]
            ),
            _c(
              "span",
              {
                staticClass: "title-name",
                class: _vm.type == 2 ? "title-more" : "",
                on: { click: _vm.getnewGroupChatData }
              },
              [_vm._v("新增群聊趋势")]
            )
          ])
        ]),
        _c("div", {
          staticStyle: { width: "100%", height: "277px" },
          attrs: { id: "zheXiangTu" }
        }),
        _vm.type == 1
          ? _c("div", { staticClass: "flag-color" }, [_vm._m(0)])
          : _c("div", { staticClass: "flag-color" }, [_vm._m(1)])
      ]),
      _c("div", { staticClass: "bottom-wrap" }, [
        _c("div", { staticClass: "staff-rank-wrap" }, [
          _c("div", { staticClass: "head-wrap" }, [
            _c("div", { on: { click: _vm.customerStatisticsShow } }, [
              _c("span", { staticClass: "title-name" }, [
                _vm._v("员工好友概况")
              ]),
              _vm._m(2)
            ]),
            _c("span", { staticClass: "tip" }, [
              _vm._v("(本表为历史数据总和，不受页面左上角时间控制)")
            ])
          ]),
          _c("div", { staticClass: "table-wrap" }, [
            _c(
              "div",
              { staticClass: "table-data" },
              [
                _c(
                  "el-table",
                  {
                    ref: "singleTable",
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "font-size": "13px"
                    },
                    attrs: {
                      size: "medium",
                      "header-cell-style": {
                        background: "#eef1f6",
                        color: "#606266"
                      },
                      "highlight-current-row": true,
                      data: _vm.staffRankData,
                      "default-sort": {
                        prop: "bindDangAnCount",
                        order: "descending"
                      },
                      height: "353px"
                    },
                    on: { "sort-change": _vm.customerSortChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "序号", width: "65", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.pageparm.pageSize *
                                      (_vm.pageparm.currentPage - 1) +
                                      (scope.$index + 1)
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "userName",
                        label: "员工姓名",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "bindDangAnCount",
                        sortable: "custom",
                        label: "绑定档案数",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "bindCusCount",
                        sortable: "custom",
                        label: "绑定客户数",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "friendNumb",
                        sortable: "custom",
                        label: "好友总数",
                        "min-width": "88",
                        align: "center"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "staff-pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.pageparm.currentPage,
                    "page-size": _vm.pageparm.pageSize,
                    layout: "prev, pager, next, jumper",
                    total: _vm.pageparm.total
                  },
                  on: {
                    "current-change": _vm.callBack,
                    "update:currentPage": function($event) {
                      return _vm.$set(_vm.pageparm, "currentPage", $event)
                    },
                    "update:current-page": function($event) {
                      return _vm.$set(_vm.pageparm, "currentPage", $event)
                    }
                  }
                })
              ],
              1
            )
          ])
        ]),
        _c("div", { staticClass: "staff-rank-wrap" }, [
          _c("div", { staticClass: "head-wrap" }, [
            _c("div", { on: { click: _vm.customerChatShow } }, [
              _c("span", { staticClass: "title-name" }, [
                _vm._v("员工群聊概况")
              ]),
              _vm._m(3)
            ]),
            _c("span", { staticClass: "tip" }, [
              _vm._v("(本表为历史数据总和，不受页面左上角时间控制)")
            ])
          ]),
          _c("div", { staticClass: "table-wrap" }, [
            _c(
              "div",
              { staticClass: "table-data" },
              [
                _c(
                  "el-table",
                  {
                    ref: "singleTable",
                    staticStyle: {
                      width: "100%",
                      height: "100%",
                      "font-size": "13px"
                    },
                    attrs: {
                      size: "medium",
                      "header-cell-style": {
                        background: "#eef1f6",
                        color: "#606266"
                      },
                      "highlight-current-row": true,
                      data: _vm.groupChat,
                      "default-sort": {
                        prop: "bindDangAnCount",
                        order: "descending"
                      },
                      height: "353px"
                    },
                    on: { "sort-change": _vm.customerSortChange }
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "序号", width: "65", align: "center" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.pageParmChat.pageSize *
                                      (_vm.pageParmChat.currentPage - 1) +
                                      (scope.$index + 1)
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _c("el-table-column", {
                      attrs: {
                        "show-overflow-tooltip": "",
                        prop: "userName",
                        label: "员工姓名",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "memberHasMsg",
                        label: "活跃群聊数",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "msgTotal",
                        label: "群聊消息数",
                        "min-width": "88",
                        align: "center"
                      }
                    }),
                    _c("el-table-column", {
                      attrs: {
                        prop: "memberTotal",
                        label: "群聊人数",
                        "min-width": "88",
                        align: "center"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "staff-pagination" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    "current-page": _vm.pageParmChat.currentPage,
                    "page-size": _vm.pageParmChat.pageSize,
                    layout: "prev, pager, next, jumper",
                    total: _vm.pageParmChat.total
                  },
                  on: {
                    "current-change": _vm.callBackChat,
                    "update:currentPage": function($event) {
                      return _vm.$set(_vm.pageParmChat, "currentPage", $event)
                    },
                    "update:current-page": function($event) {
                      return _vm.$set(_vm.pageParmChat, "currentPage", $event)
                    }
                  }
                })
              ],
              1
            )
          ])
        ])
      ]),
      _c("StatisticDialog", { ref: "tipDialog" }),
      _c("customerStatistics", { ref: "customerStatistics" }),
      _c("customerChat", { ref: "customerChat" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "line-type" }, [
      _c("div", { staticClass: "type-item" }, [
        _c("div", { staticClass: "dot xin-zeng-dot" }),
        _c("div", { staticClass: "type-name" }, [_vm._v("新增客户")])
      ]),
      _c("div", { staticClass: "type-item" }, [
        _c("div", { staticClass: "dot xin-bang-dot" }),
        _c("div", { staticClass: "type-name" }, [_vm._v("新绑档案")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "line-type" }, [
      _c("div", { staticClass: "type-item" }, [
        _c("div", { staticClass: "dot xin-zeng-dot" }),
        _c("div", { staticClass: "type-name" }, [_vm._v("新增群聊")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-more" }, [
      _vm._v("更多"),
      _c("i", { staticClass: "el-icon-arrow-right" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "title-more" }, [
      _vm._v("更多"),
      _c("i", { staticClass: "el-icon-arrow-right" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }